import React from 'react';

export const MechanicStatusChip = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 15"
      stroke={color}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 10.9219H9.90909" stroke={color} strokeWidth="1.03434" />
      <path
        d="M3.53686 10.8842H0.863064V8.32868C0.863064 7.74274 1.25711 7.23004 1.82333 7.07928L3.76022 6.56357C4.02752 6.4924 4.26496 6.33737 4.43764 6.12127L6.81869 3.14136C6.94137 2.98783 7.12722 2.89844 7.32374 2.89844H9.18182"
        stroke={color}
        strokeWidth="1.03434"
      />
      <circle
        cx="5.42631"
        cy="10.8831"
        r="1.71123"
        stroke={color}
        strokeWidth="1.03434"
      />
      <g clipPath="url(#clip0_232_32237)">
        <path
          d="M10.7378 12.372V7.38806C9.86149 7.00468 9.25903 6.12838 9.25903 5.08778C9.25903 3.99241 9.97102 3.06134 10.9295 2.70535L10.9295 5.0604L12.5725 5.0604L12.5999 2.67796C13.5858 3.00657 14.2704 3.96502 14.2704 5.0604C14.2704 6.101 13.6679 6.9773 12.7916 7.36068L12.7916 12.3446C12.7916 12.5637 12.6273 12.728 12.4082 12.728L11.1485 12.728C10.9021 12.7554 10.7104 12.5637 10.7378 12.372Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_232_32237">
          <rect
            width="9.29455"
            height="9.29455"
            fill={color}
            transform="matrix(-0.707107 0.707107 0.707107 0.707107 11.7511 0.953125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
